export const components = {
  deprecated: {
    template: /* html */`
      <span class="badge bg-danger rounded-pill">deprecated</span>
    `,
  },
  raitt: {
    template: /* html */`
      <span class="badge bg-primary rounded-pill">new raitt</span>
    `,
  },
  attribute: {
    template: /* html */`
      <span class="badge bg-warning rounded-pill">attribute</span>
    `,
  },
};
